import PlatformFooter from '../appComponents/mobile/PlatformFooter';
import '../appComponents/desktop/css/PlatformFooterDesktop.css';
import '../appComponents/desktop/css/DesktopModalStyles.css';
import { switchPlatformTheme } from '../appComponents/shared/ThemePreference';
import '../appComponents/shared/css/PlatformExperience.css';
import PageLoading from '../appComponents/shared/PageLoading';
import { trackPageRequest } from '../appComponents/shared/PageLoadingService';
import '../appComponents/shared/crypto/css/OverlayTheme.css';
import { authenticatedPut } from '../appComponents/shared/AuthenticatedAPI';
import PasswordPrompt from '../appComponents/shared/crypto/PasswordPrompt';
import CryptoMoneyPanel from '../appComponents/shared/crypto/CryptoMoneyPanel';
import React, { Component } from 'react';

class MemberTransactionsDesktopRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Bar, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, CartesianGrid, Chart, Component, Container, CryptoJS, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Legend, Line, LineChart, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, MemberTransactions, Modal, Mosaic, OrbitProgress, Radio, React, ReactSearchAutocomplete, ResponsiveContainer, Storage, ThreeDot, Tooltip, Web3, XAxis, YAxis, _approverReceivedRepaymentSum, _approversCt, _approversLoanTotal, _availableCreditReadyWithdraw, _balance, _blenderScore, _blockchainBalance, _borrowerInterestPaid, _borrowingRec, _canDeleteCreditLineBool, _compoundedBalance, _compoundedBalanceWEI, _currentUserContribution, _dateCreated, _exitReclaimableValueWei, _fico, _intRate, _joinDate, _lenders, _lendingRate, _lentTotal, _loanRate, _lookupKey, _managerLCase, _minLoan, _offeredLenderCommissionUSD_adjusted, _openValue, _payableValue, _reclaimableValue, _repayRate, _repaymentTotal, _riskCoverage, _safeReclaimableValueWei, _targetValue, _totalBorrowing, _totalContributed, _totalContributedWei, _totalLending, _totalPaid, _totalWithdrawn, _txnSectionHelpText, _userAvgRating, _userContributed, _userFinalized, _userInterestEarned, _values, _valuesONLY, _web3Balance, _weiCompoundedBalance, _withdrawalRate, accountStatsArray, actionButton, actionText, actionType, actionTypeStakingBool, approverCheck, approverReceivedRepaymentSum, approversCount, approversList, availableCredit, availableCreditRatio, availableCredit_unadjusted, awsconfig, axios, blacklisted, blenderCommissionPublicKey, blenderPercentCharge, blenderPrivateKey, blenderScore, blenderTransfersToPublicKey, borrowerInterestPaid, borrowerStatsArray, borrowingRec, buttonColorFlashIntervalDefault, buttonColorFlashIntervalSecondary, buttonText, campaign, checkValidAuthTokenIntervalPeriod_ms, className, client, closureDateFormatted, cognitoID, compoundInterestReceived, compoundedInterestPaid, contractAddress, contractBalance, contractReceipts, contractStructureType, contributeSignatureNeeded, conversionRateGlobal, corporateBackedUsernamesArray, costText, creditUtilizationPerc, currentUser, currentUserCap, currentUserLoanTotal, dataIndexDayMap, deploymentAddress, displayValue, dob, emailAddress, errorWarningOverlayTimeout, ethers, fico, finalRequestsSum, firstName, forexJSON, formattedValueTooltipString, fullAddress, highRateWeb3, imaginaryInsuranceTotal, insuranceTotal, intRate, interactionHeader, interestRate, ipAddress, isCorporateBondBool, isMobile, isSubscribedCurrentBool, lastName, lenderCount, lendingRate, loadingTextInterval, loadingTextIntervalCt, loanRate, loanTarget, manager, managerDisplay, managerUsername, maxDayValue, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, minDayValue, minLoan, minimumContribution, mode_light_dark, monthLengtheningEnum, navigationHandler, netDebt, noDailyDataPointsFoundBool, offeredLenderCommissionUSD, openContracts, openValue, phoneNumber, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, privateKey, proposeGasPrice, publicKey, rand1, receiptsCt, reclaimableValue, region, repaidRec, repayRate, repaymentSum, requests, requestsCt, riskCoveragePercentage, routeProps, secondaryDisplayCurrency, secondaryDisplayPrice, secretName, settlementDateFormatted, squareCustomerID, streetAddress, targetValue, that, thisContract_CampaignContract, thisContract_CampaignFactoryContract, thisDeploymentAddress, tokenLifeTimeLimit, tooltipInterval, totalBorrowing, totalContributed, totalCreditMax, totalLending, totalPaid, totalValue, totalWithdrawn, touched, transactionValue, useLayoutEffect, useParams, useRef, userContributed, userFinalized, userFinalizedRequestLoanSum, userInterestEarned, userLiquidValue, userLiquidValuePre, userRiskValue, value, valueDelta, walletBalanceWei, web3, web3BalancePost, web3BalancePre, wishlist, wishlistIcon, withdrawalRate } = this.props;

    return (
(
          <div className={"pageBody tbp-platform tbp-platform--" + (that.state.mode_light_dark === 'light' ? 'light' : 'dark') + " tbp-platform--member-transactions tbp-platform--desktop"}>
              <PageLoading theme={that.state.mode_light_dark} language={that.state.selectedLanguage} busy={Boolean(that.state.freezeButtonsBool || that.state.activityIndicator === true)} />

            
            <head>
              <script src="https://www.gstatic.com/charts/loader.js"></script>
            </head>
            

            
            


              
              
              
                
              <PasswordPrompt desktop
              open={that.state.showPasswordOverlay}
              theme={that.state.mode_light_dark}
              language={that.state.selectedLanguage}
              message={that.state.transactionConfirmationMessage}
              value={that.state.passwordText || ''}
              onChange={(event) => {
                            that.setState({
                              passwordText: event.target.value
                            })
                        }}
              onConfirm={() => {
                          that.setState({
                            showPasswordOverlay: false,
                            pendingTransactionLoaderOverlay: true,
                          })
                          if(that.state.moneyTransactionPreset == 'deposit'){
                            that.chargeUserLinked()
                          } else if(that.state.moneyTransactionPreset == 'transfer'){
                            that.sendTransferFinal()
                          } else if(that.state.moneyTransactionPreset == 'withdrawal'){
                            that.withdrawEther()
                          }
                        }}
              onCancel={() => {
                that.setState({
                  showPasswordOverlay: false,
                  passwordText: null,
                  passwordIsHiddenBool: true,
                })
              }}
            />


            



              <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.pendingTransactionLoaderOverlay}
                // open={true}
                style={{
                  width: '18vw',
                }}
                // trigger={<Button>Show Modal</Button>}
              >
                <Modal.Header
                  style={{
                    paddingLeft: '7vh',
                  }}
                >
                  
                  The Blender Platform
                </Modal.Header>
                <Modal.Content image>
                  <Modal.Description>
                    <Header
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginLeft: '2vw',
                        marginRight: '3vw',
                        marginTop: '0vw',
                        marginBottom: '0vw',
                        height: '5vw',
                      }}
                    >
                      <p
                        style={{
                          fontSize: 19,
                          color: 'rgba(0, 0, 0, 1)',
                          textAlign: 'left',
                          marginBottom: '2vh',
                        }}
                      >
                        {
                          that.state.selectedLanguage == 'spanish' 
                          ? 
                            "Transacción Pendiente"
                          :
                            "Transaction in Progress"
                        }
                      </p>
                      
                      <div
                        style={{
                          justifyContent: 'center',
                          alignItems: 'center',
                          width: '4vw',
                          marginLeft: '3vw',
                          marginRight: '3vw',
                          // paddingLeft: '5vw',
                          // paddingRight: '5vw', 
                        }}
                      >
                        <div className="tbp-overlay-loading"><ThreeDot 
                          color="rgba(0, 158, 129, 1)" 
                          size="large" 
                          style={{
                            marginTop: 250,
                            speedPlus: -2,
                          }}
                        /></div>
                      </div>
                    
                    </Header>
                    
                  </Modal.Description>
                  
                </Modal.Content>
              </Modal>
              
        
              <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                  open={that.state.errorTags}
                  // open={true}
                  style={{
                  width: '25vw',
                  justifyContent: 'center',
                  alignItems: 'center',
                  }}
              >
                  <Modal.Header
                    style={{
                      paddingLeft: '7vh',
                    }}
                  >
                    
                    The Blender Platform
                  </Modal.Header>
                
                  <Modal.Content 
                  image
                  style={{
                      justifyContent: 'space-between',
                      marginBottom: '1vh',
                  }}
                  >
                  
                  <Modal.Description
                      style={{
                      width: '25vw',
                      }}
                  >
                      <Header
                      style={{
                          // left: '16vw',
                          fontSize: 20,
                          // position: 'absolute',
                          overflowY: 'hidden',
                          overflowX: 'hidden', 
                          width: '25vw',
                          marginBottom: 65,
                          paddingRight: '1vw',
                      }}
                      >
                          <p
                          style={{
                              color: 'rgba(235, 50, 38, 1)',
                              textAlign: 'left',
                              textWrap: 'wrap',
                          }}
                          >
                          {that.state.selectedLanguage == 'spanish' ? 
                              'Error:'
                                  :
                              'Error:'
                          }
                          </p>
                          <p
                          style={{
                              color: 'rgba(0, 0, 0, 1)',
                              textAlign: 'left',
                              textWrap: 'wrap',
                              fontWeight: '400',
                              fontSize: 18,
                              paddingRight: '1vw',
                          }}
                          >
                          {that.state.errorTags}
                          </p>
                      </Header>
                  </Modal.Description>
                  </Modal.Content>
                  <Button
                      content={
                          that.state.selectedLanguage == 'spanish' ? 
                          'Bueno'
                              :
                          'Okay'
                      }
                      labelPosition='right'
                      icon='checkmark'
                      onClick={() => {
                          that.setState({
                              successfulDepositOverlay: false,
                              errorTags: null
                          })
                      }}
                      positive
                      style={{
                          backgroundColor: 'rgba(0, 158, 129, 1)',
                          position: 'relative',
                          bottom: 21,
                          fontSize: 15,
                          width: '7vw',
                          marginLeft: '9vw',
                          marginRight: '9vw',
                          // left: '0vw',
                          borderRadius: 2,
                      }}
                  />
              </Modal>



              <Modal centered={false} dimmer={{ className: "tbp-overlay-backdrop" }} className={"tbp-desktop-modal tbp-overlay " + (that.state.mode_light_dark == "light" ? "light" : "dark")}
                open={that.state.generalNoticeOverlay}
                // open={true}
                style={{
                  width: '29vw',
                  height: '25vh',
                }}
                // trigger={<Button>Show Modal</Button>}
              >
                <Modal.Header
                  style={{
                    paddingLeft: '7vh',
                  }}
                >
                  
                  The Blender Platform
                </Modal.Header>
                  
                  
                <Modal.Content image>
                  <Modal.Description>
                    <Header
                      style={{
                        left: '1vw',
                        marginRight: '1vw',
                        position: 'absolute',
                      }}
                    >{`${that.state.generalNoticeText}`}</Header>
                    <Button
                      content="Okay"
                      labelPosition='right'
                      icon='checkmark'
                      onClick={() => {
                        that.setState({
                          generalNoticeOverlay: false,
                        })
                      }}
                      positive
                      style={{
                        backgroundColor: 'rgba(0, 158, 129, 1)',
                        position: 'absolute',
                        bottom: 21,
                        width: '7vw',
                        left: '11vw',
                      }}
                    />
                  </Modal.Description>
                
                  
                </Modal.Content>
              </Modal>

              <div className="tbp-platform__sidebar" style={{
                  // borderRadius: 10,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '13vw',
                  height: '100vh',
                  margin: 0,
                  left: 0,
                  position: 'absolute',
                  borderRightStyle: 'solid',
                  borderWidth: 0.1,
                  borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                  backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
                }}>
                  <Button
                    onClick={() => {
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/home',
                        },
                      })
                    }}
                    style={{
                      position: 'relative',
                      left: '2vw',
                      top: '1vw',
                      height: '5vw',
                      width: '5vw',
                      marginBottom: '2vh',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'rgba(0, 0, 0, 0)',
                    }}
                  >
                    <img 
                      // className="logoImage" 
                      src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"
                      style={{
                        height: '4vw',
                        width: '4vw',
                        position: 'absolute',
                        top: 7, 
                        left: 3, 
                        right: 0,
                        borderRadius: 7,
                        borderStyle: 'solid',
                        borderWidth: 0.1,
                        borderColor: 'rgba(177, 177, 177, 0.1)',
                      }}
                    />
                  </Button>
                  


                  <List>
                    <ListItem
                      style={{
                        marginBottom: 10,

                        marginLeft: 25
                      }}
                    >
                      <button 
                        style={{
                          borderRadius: 20,
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          borderWidth: 2,
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 15,
                        }}
                        className="ui huge teal button"
                        onClick={() => {
                          that.setState({
                            navigationDestinationObject: {
                                navigationRoute: '/home',
                            },
                          })
                        }}
                      >
                        <p
                          style={{
                            fontSize: 16,
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            textAlign: 'left'
                          }}
                        >
                          <i className="home icon"/>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Activos'
                              :
                            'Accounts'
                          }
                        </p>
                      </button>
                    </ListItem>
                    <ListItem
                      style={{
                        marginBottom: 10,
                        marginLeft: 25
                      }}
                    >
                      <button 
                        onClick={() => {
                          that.setState({
                            navigationDestinationObject: {
                                navigationRoute: '/browser',
                            },
                          })
                        }}
                        style={{
                          borderRadius: 20,
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          borderWidth: 2,
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 15,
                        }}
                        className="ui huge teal button"
                        
                      >
                        <p
                          style={{
                            fontSize: 16,
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            textAlign: 'left'
                          }}
                        >
                          <i className="search icon"></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Buscar'
                              :
                            'Browse'
                          }
                        </p>
                        
                      </button>
                    </ListItem>

                    <ListItem
                      style={{
                        marginBottom: 10,
                        marginLeft: 25
                      }}
                    >
                      <button 
                        style={{
                          borderRadius: 20,
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          borderWidth: 2,
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 15,
                        }}
                        onClick={() => {
                          that.setState({
                            navigationDestinationObject: {
                                navigationRoute: '/newborrowingacct',
                            },
                          })
                        }}
                        className="ui huge teal button"
                          
                      >
                        <p
                          style={{
                            fontSize: 16,
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            textAlign: 'left'
                          }}
                        >
                          <i className="newspaper icon"></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Tomar Prestamo'
                              :
                            'Borrow Funds'
                          }
                        </p>
                        
                      </button>
                    </ListItem>
                    <ListItem
                      style={{
                        marginBottom: 10,
                        marginLeft: 25
                      }}
                    >
                      <button 
                        // onClick={() => {
                        //   that.setState({
                        //     navigationDestinationObject: {
                        //         navigationRoute: '/membertransactions',
                        //     },
                        //   })
                        // }}
                        style={{
                          borderRadius: 20,
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          borderWidth: 2,
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 15,
                        }}
                        className="ui huge teal button"
                      >
                        <p
                          style={{
                            fontSize: 16,
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            textAlign: 'left'
                          }}
                        >
                          <i className="wait icon"></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Transacciones'
                              :
                            'Transactions'
                          }
                        </p>
                        
                      </button>
                    </ListItem>
                    <ListItem
                      style={{
                        marginBottom: 10,
                        marginLeft: 25
                      }}
                    >
                      <button 
                        style={{
                          borderRadius: 20,
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          borderWidth: 2,
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 15,
                        }}
                        onClick={() => {
                          that.setState({
                            navigationDestinationObject: {
                                navigationRoute: '/SubscriptionPlan',
                            },
                          })
                        }}
                        className="ui huge teal button"
                      >
                        <p
                          style={{
                            fontSize: 16,
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            textAlign: 'left'
                          }}
                        >
                          <i className="star icon"></i>
                          &nbsp;  
                          {'Blender Pro Plus'}
                        </p>
                        
                      </button>
                    </ListItem>
                    <ListItem
                      style={{
                        marginBottom: 10,
                        marginLeft: 25
                      }}
                    >
                      <button 
                        style={{
                          borderRadius: 20,
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          borderWidth: 2,
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 15,
                        }}
                        onClick={() => {
                          var win = window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank');
                          win.focus();
                        }}
                        className="ui huge teal button"
                      >
                        <p
                          style={{
                            fontSize: 16,
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            textAlign: 'left'
                          }}
                        >
                          <i className="book icon"></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Condiciones'
                              :
                            'Terms of Use'
                          }
                        </p>
                        
                      </button>
                    </ListItem>
                    <ListItem
                      style={{
                        marginBottom: 10,
                        marginLeft: 25
                      }}
                    >
                      <button 
                        style={{
                          borderRadius: 20,
                          backgroundColor: 'rgba(0, 158, 129, 0)',
                          borderWidth: 2,
                          justifyContent: 'center',
                          alignItems: 'center',
                          padding: 15,
                        }}
                        onClick={() => {
                          var win = window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank');
                          win.focus();
                        }}
                        className="ui huge teal button"
                      >
                        <p
                          style={{
                            fontSize: 16,
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                            textAlign: 'left'
                          }}
                        >
                          <i className="book icon"></i>
                          &nbsp;
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Privacidad'
                              :
                            'Privacy Policy'
                          }
                        </p>
                        
                      </button>
                    </ListItem>
                  </List>


                  <button 
                    
                    style={{
                      position: 'fixed',
                      bottom: 20,
                      marginBottom: 10,
                      marginLeft: 25,
                      borderRadius: 20,
                      backgroundColor: 'rgba(0, 158, 129, 0)',
                      borderWidth: 2,
                      justifyContent: 'center',
                      alignItems: 'center',
                      padding: 15,
                    }}
                    onClick={() => { 
                      trackPageRequest(Auth.signOut())
                      that.setState({
                        navigationDestinationObject: {
                            navigationRoute: '/welcome',
                        },
                      }) 
                    }}
                    className="ui medium teal button"
                  >
                    <p
                      style={{
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                      }}
                    >
                      <i className="sign out icon"/>
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Desconectar'
                          :
                        'Sign Out'
                      }
                    </p>
                  </button>
              </div>



              <div className="tbp-platform__workspace" style={{
                // backgroundColor: 'blue',
                // borderRadius: 10, 
                justifyContent: 'center',
                alignItems: 'center',
                width: '87vw',
                height: '100vh',
                margin: 0,
                flexDirection: 'column',
                // borderStyle: 'none',
                borderWidth: 0,    
                position: 'absolute',
                left: '13vw',
                top: '0vh',
                // border: 'none',   
                // borderColor: 'rgba(177, 177, 177, 0)',
              }}>
              

                <div className="tbp-platform__topbar" style={{
                  // backgroundColor: 'rgba(0, 158, 129, 0)',
                  // borderRadius: 10,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '87vw',
                  height: '7vh',
                  paddingLeft: '3vw',
                  margin: 0,
                  display: 'flex',
                  flexDirection: 'row',
                  paddingRight: '10vw',
                  borderBottomStyle: 'solid',
                  borderWidth: 0.1,
                  borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                  backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
                }}>
                  <p 
                    style={{ 
                      textAlign: 'left',
                      textAlignVertical: 'center',
                      fontSize: 23, 
                      fontWeight: '600', 
                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                      marginTop: 30, 
                      marginBottom: 30,
                      // textUnderlineOffset: 3, 
                      // textDecorationLine: 'underline', 
                      // textDecorationColor: 'rgba(255, 255, 255, 1)',
                    }}
                  >
                      <span className="tbp-platform__eyebrow">THE BLENDER PLATFORM</span><span className="tbp-platform__title">{that.state.selectedLanguage === 'spanish' ? "Transacciones" : "Transactions"}</span>  
                  </p>


                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      position: 'absolute',
                      right: 0,
                      padding: 10,
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      paddingRight: 25,
                      borderRadius: 17
                    }}
                  >
                    <Button
                      onClick={() => {
                        that.setState({
                          navigationDestinationObject: {
                              navigationRoute: '/accountmanagement',
                          },
                        })
                      }}
                      style={{
                        borderBottomLeftRadius: 18,
                        borderBottomRightRadius: 5,
                        borderTopLeftRadius: 18,
                        borderTopRightRadius: 5,
                        height: '40px',
                        borderWidth: 2,
                        marginLeft: 25,
                        marginRight: 10,
                        backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 1)' : 'rgba(35, 35, 35, 1)', 
                        borderColor: 'rgba(224, 225, 226, 0)',
                        borderStyle: 'solid', 
                        justifyContent: 'center',
                        alignItems: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        transitionDuration: '0.4s',
                        cursor: 'pointer',
                        padding: 0,
                      }}
                    >
                      <img 
                        className="header_profileImage" 
                        width="35" 
                        height="35" 
                        src={that.state.currentUserProfilePicture}
                      />

                      <p 
                        style={{ 
                          textAlign: 'right',
                          textAlignVertical: 'center',
                          fontSize: 16, 
                          fontWeight: '600', 
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                          marginLeft: 12, 
                          marginRight: 15,
                          marginTop: 5,
                          // textUnderlineOffset: 3, 
                          // textDecorationLine: 'underline', 
                          // textDecorationColor: 'rgba(255, 255, 255, 1)',
                        }}
                      >
                          {String(that.state.currentUser).toUpperCase()}
                      </p>
                    </Button>
                  </div>



                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      position: 'absolute',
                      right: 200,
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: 17,
                      backgroundColor: 'rgba(35, 35, 35, 0)',
                      borderRadius: 17,
                      width: '5vw',
                      height: '7vh', 
                    }}
                  >


                    <button
                      style={{
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '2.5vw',
                        height: '7vh', 
                        paddingTop: '2.5vh',
                        paddingBottom: '1vh',
                        backgroundColor: 'rgba(35, 35, 35, 0)',
                        borderStyle: 'none',
                      }}
                      onClick={() => switchPlatformTheme({ that, authenticatedPut, currentUser })}
                    >
                      <p style={{ 
                        justifyContent: 'center',
                        textAlign: 'center',
                        textAlignVertical: 'center',
                        color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                        fontWeight: '600',
                      }}>
                        <p style={{ 
                          justifyContent: 'center',
                          textAlign: 'center',
                          textAlignVertical: 'center',
                          color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',

                          fontWeight: '600',
                        }}>
                          <i
                            style={{
                              fontSize: that.state.mode_light_dark == 'dark' ? 34 : 31, 
                              marginBottom: 5, 
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                              marginLeft: 5,
                            }}
                            className={that.state.mode_light_dark == 'dark' ? "sun icon" :"moon icon"}
                          />
                        </p>
                      </p>
                    </button>

                  </div>   

                </div>
                
                <div className="tbp-platform__body" style={{
                  // backgroundColor: 'blue',
                  // borderRadius: 10,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '87vw',
                  height: '93vh',
                  margin: 0,
                  borderStyle: 'none',
                  borderWidth: 0,
                  backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
                }}>
                  <div 
                    class="scrollNoScrollBar"
                    style={{
                      // borderRadius: 10,
                      // backgroundColor: 'red',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '62vw',
                      position: 'fixed',
                      left: '13vw',
                      // top: 0, 
                      // bottom: 0, 
                      height: '93vh',
                      marginTop: 0,
                      marginBottom: 0,
                      marginRight: 0,
                      marginLeft: '0vw',
                      borderStyle: 'none',
                      borderWidth: 0,
                      scrollbarWidth: 'none',
                      overflowY: 'auto',
                      overflowX: 'hidden'
                    }}
                  >

                    <div 
                      style={{ 
                        zIndex: 2, 
                        position: 'relative',
                        top: 0, 
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '62vw', 
                        minHeight: '88vh',
                        marginRight: '2vw', 
                        paddingRight: '3vw', 
                      }}  
                    >




                      <div style={{ zIndex: 2, position: 'relative', top: 0, width: '60vw', minHeight: '88vh', padding: '3vw', paddingTop: 20 }}>
                        {/* The page title already identifies Transactions. */}
                        <div
                          style={{
                            zIndex: 99999,
                            width: '60vw',
                            minHeight: 50,
                            paddingLeft: '0vw',
                            paddingRight: '5vw',
                            paddingTop: '1vh',
                            borderRadius: 3,
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: '4vh',
                          }}
                        >
                          <React.Fragment>
                              {that.state.receiptList.map(listItem => (
                              
                                    
                                  <Link 
                                    to={`/borrowingacct/${listItem.contractLookupID}`}
                                    onClick={() => {
                                    }}
                                    disabled={listItem.disabled}
                                    style={{
                                      borderWidth: 0,
                                      display: 'flex',
                                      paddingLeft: 0,
                                      width: '60vw',
                                      height: '60px',
                                      paddingRight: 0,
                                      flexDirection: "row",
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      backgroundColor: 'rgba(255, 255, 255, 0)',
                                    }}
                                  >


                                        <div 
                                          style={{
                                            width: '15vw',
                                            height: '20px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: 20, 
                                            marginBottom: 20,
                                            paddingLeft: 0,
                                          }}
                                        >
                                          <p style={{
                                            justifyContent: 'center',
                                            textAlign: 'left',
                                            textAlignVertical: 'center',
                                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                            fontSize: 14,
                                            fontWeight: '600',
                                            left: 0, 
                                          }}>
                                            {listItem.actionType}
                                          </p>
                                        </div>
                                        <div 
                                          style={{
                                            width: '15vw',
                                            height: '20px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: 20, 
                                            marginBottom: 20,
                                            paddingLeft: 45,
                                          }}
                                        >
                                          <p style={{ 
                                            justifyContent: 'center',
                                            textAlign: 'left',
                                            textAlignVertical: 'center',
                                            color: 'rgba(0, 158, 129, 1)',
                                            fontSize: 14,
                                            fontWeight: '600',
                                            left: 0, 
                                          }}>
                                            {listItem.value}{' USD'}
                                          </p>
                                        </div>
                                        <div 
                                          style={{
                                            width: '15vw',
                                            height: '20px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: 20, 
                                            marginBottom: 20,
                                            paddingLeft: 45,
                                          }}
                                        >
                                          <p style={{ 
                                            justifyContent: 'center',
                                            textAlign: 'left',
                                            textAlignVertical: 'center',
                                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                            fontSize: 14,
                                            fontWeight: '600',
                                            left: 0, 
                                          }}>
                                            {listItem.manager}
                                          </p>
                                        </div>
                                        <div 
                                          style={{
                                            width: '16vw',
                                            height: '20px',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            marginTop: 20, 
                                            marginBottom: 20,
                                            paddingLeft: 45,
                                          }}
                                        >
                                          <p style={{ 
                                            justifyContent: 'center',
                                            textAlign: 'left',
                                            textAlignVertical: 'center',
                                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                                            fontSize: 14,
                                            fontWeight: '600',
                                            left: 0, 
                                          }}>
                                            {String(listItem.dateNow).toUpperCase()}
                                          </p>
                                        </div>
                                        
                                  </Link>


                              ))}
                          </React.Fragment>
                        </div>
                      </div>
                    



                    </div>

                    <PlatformFooter language={that.state.selectedLanguage} />

                  </div>

                  <div className="tbp-money-rail" style={{
                    alignItems: 'center',
                    width: '25vw',
                    position: 'fixed',
                    right: 0,
                    // top: 0, 
                    // bottom: 0, 
                    height: '93vh',
                    marginTop: 0,
                    marginBottom: 0,
                    marginRight: 0,
                    marginLeft: '65vw',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderLeftStyle: 'solid',
                    borderWidth: 0.1,
                    borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',

                  }}>
                      <div
                        style={{
                          marginBottom: 25,
                          height: '93vh',
                          marginTop: 0,
                          width: '25vw',
                          borderRadius: 0,
                          justifyContent: 'center',
                          alignItems: 'center',
                          fontSize: 14, 
                          fontWeight: '600',
                        }}
                        // disabled={true}
                      >
                        <div
                          style={{
                            flexDirection: 'row',
                            display: 'flex',
                            width: '25vw',
                          }}
                        >
                          <Button aria-pressed={String(that.state.moneyTransactionPreset).toLowerCase() === "deposit"}
                            onClick={() => {
                              that.setState({
                                moneyTransactionPreset: 'deposit'
                              })
                            }}
                            style={{
                              backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'deposit' ? 
                                (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                                : 
                                (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                              width: '8.33vw',
                              height: '5.3vh',
                              // borderTopLeftRadius: '5px',
                              // borderBottomLeftRadius: '5px',
                              borderColor: 'rgba(177, 177, 177, 0)',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: 0, 
                              marginRight: 0,
                              paddingLeft: 10, 
                              paddingRight: 10,
                              borderRightStyle: 'none',
                              borderWidth: 0.1,
                              borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                              borderRadius: 0,
                            }}
                          >
                            <p
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 16,
                                fontWeight: '600',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Depositar'
                                :
                                'Deposit'
                              }
                            </p>
                          </Button>
                          <Button aria-pressed={String(that.state.moneyTransactionPreset).toLowerCase() === "transfer"}
                            onClick={() => {
                              that.setState({
                                moneyTransactionPreset: 'transfer'
                              })
                            }}
                            style={{
                              backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'transfer' ? 
                              (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                                : 
                                (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                              width: '8.33vw',
                              height: '5.3vh',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: 0, 
                              marginRight: 0,
                              paddingLeft: 10, 
                              paddingRight: 10,
                              borderRightStyle: 'none',
                              borderWidth: 0.1,
                              borderColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                              borderRadius: 0,
                            }}
                          >
                            <p
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 16,
                                fontWeight: '600',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Transferir'
                                :
                                'Transfer'
                              }
                            </p>
                          </Button>
                          <Button aria-pressed={String(that.state.moneyTransactionPreset).toLowerCase() === "withdraw"}
                            onClick={() => {
                              that.setState({
                                moneyTransactionPreset: 'withdraw'
                              })
                            }}
                            style={{
                              backgroundColor: String(that.state.moneyTransactionPreset).toLowerCase() == 'withdraw' ? 
                              (that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)') 
                                : 
                                (that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(41, 41, 41, 0.1)'),
                              width: '8.33vw',
                              height: '5.3vh',
                              borderTopRightRadius: '5px',
                              borderBottomRightRadius: '5px',
                              borderColor: 'rgba(177, 177, 177, 0)',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                              justifyContent: 'center',
                              alignItems: 'center',
                              marginLeft: 0, 
                              marginRight: 0,
                              paddingLeft: 10, 
                              paddingRight: 15,
                              borderRadius: 0,
                            }}
                          >
                            <p
                              style={{
                                color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                textAlign: 'center',
                                textAlignVertical: 'center',
                                fontSize: 16,
                                fontWeight: '600',
                              }}
                            >
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Retirar'
                                :
                                'Withdraw'
                              }
                            </p>
                          </Button>
                        </div>
{['deposit','withdraw'].includes(that.state.moneyTransactionPreset) ? <CryptoMoneyPanel desktop key={that.state.moneyTransactionPreset} mode={that.state.moneyTransactionPreset} theme={that.state.mode_light_dark} language={that.state.selectedLanguage} onComplete={() => { if(publicKey)trackPageRequest(web3.eth.getBalance(publicKey)).then(balance => that.setState({walletBalanceWei: balance, walletBalanceUSD: Number(balance) / 1000000000000000000})).catch(() => {}); }} /> : <>
                        <p
                          style={{
                            position: 'absolute',
                            top: '9vh', 
                            bottom: '9vh', 
                            right: '2vw',
                            fontSize: 60,
                            fontWeight: '600',
                            textAlign: 'right',
                            textAlignVertical: 'center',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 1)',
                            marginTop: -20,
                          }}
                        >
                          {'USD'}
                          <p
                            style={{
                              marginTop: -20,
                              fontSize: 60,
                              fontWeight: '600',
                              textAlign: 'right',
                              right: '2vw',
                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.7)' : 'rgba(255, 255, 255, 1)',
                            }}
                          >
                            {'.00'}
                          </p>
                        </p>
                        <input 
                          autocomplete="off" 
                          maxlength="5"
                          type="number" 
                          id="text" 
                          outline="none"
                          onChange={(event) => {
                            if(Number(event.target.value) <= 999){
                              that.setState({
                                moneyTransactionLiveValue: event.target.value
                              })
                            }
                          }} 
                          value={that.state.moneyTransactionLiveValue}
                          name="text"
                          placeholder={'0'} 
                          style={{
                            fontWeight: '600',
                            fontFamily: 'arial',
                            color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                            paddingRight: '10vw',
                            textAlign: 'center',
                            textAlignVertical: 'center',
                            fontSize: 18,
                            height: '20vh',
                            width: '25vw',
                            borderRadius: 0,
                            borderWidth: 0,
                            borderStyle: 'none',
                            fontSize: 80,
                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(41, 41, 41, 0.1)' : 'rgba(248, 246, 246, 0.1)',
                            borderBottomColor: 'rgba(177, 177, 177, 0)',
                          }}   
                        /> 
                        {
                          that.state.moneyTransactionPreset == 'transfer'
                          ?
                          <div
                            style={{
                              width: '25vw',
                              height: '6vh',
                              justifyContent: 'center',
                              alignItems: 'center',
                              // paddingLeft: '1vw',
                            }}
                          >
                            
                            <div
                              style={{
                                width: '25vw',
                                height: '6vh',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // paddingLeft: '2vw',
                                // flexDirection: 'row',
                                // display: 'flex',
                                // backgroundColor: 'red',
                              }}
                            >

                              <div
                                style={{
                                  width: '25vw-1px',
                                  marginRight: '1px',
                                  height: '4vh',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  padding: 0,
                                  paddingRight: 1,
                                  // flexDirection: 'row',
                                  // display: 'flex',
                                  // position: 'absolute',
                                  borderStyle: 'solid',
                                  borderColor: 'rgba(0, 0, 0, 0)',
                                  borderWidth: 0.1,
                                  marginTop: '0vh',
                                  marginBottom: '0vh',
                                  left: 0,
                                  right: 0,
                                  zIndex: 9999999,
                                }}
                              >
                                <ReactSearchAutocomplete
                                  items={that.state.allUserUsernamesDisplayNames}
                                  onSearch={(string, results) => {
                                    if(string){
                                      that.setState({
                                        destinationUsername: String(string).toUpperCase()
                                      })
                                    }
                                  }}
                                  showNoResults={false}
                                  onSelect={(item) => {
                                    that.setState({
                                      destinationUsername: String(item.name).toUpperCase(),
                                      activeSearchTransferBool: false,
                                    })
                                  }}
                                  maxResults='8'
                                  inputSearchString={
                                    that.state.activeSearchTransferBool
                                    ?
                                    (that.state.destinationUsername ? String(that.state.destinationUsername).toUpperCase() : '')
                                    :
                                    ''
                                  }
                                  placeholder={
                                    that.state.selectedLanguage == 'spanish' ? 
                                      "Usuario de Recipiente"
                                        :
                                      "Recipient Username"
                                  } 
                                  fuseOptions={{
                                    shouldSort: true,
                                    minMatchCharLength: 2,
                                  }}
                                  showIcon={false}
                                  showClear={true}
                                  maxLength={20}
                                  styling={{  
                                    fontWeight: 'bold',
                                    fontFamily: 'Lato',
                                    color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                    placeholderTextColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)',
                                    paddingTop: 0,
                                    paddingBottom: '100px',
                                    textAlign: 'center',
                                    textAlignVertical: 'center',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '17px',
                                    height: '4vh',
                                    width: '25vw',
                                    borderWidth: 0,
                                    borderStyle: 'none',
                                    // backgroundColor: 'blue',
                                    border: "0px solid #000000",
                                    borderRadius: "0px",

                                    backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)',
                                    lineColor: that.state.mode_light_dark == 'light' ? 'rgb(230, 230, 230)' : 'rgb(40, 44, 52)',                                
                                    borderTopColor: 'rgba(41, 41, 41, 0.1)',
                                    boxShadow: "rgba(0, 0, 0, 0) 0px 1px 6px 0px", 
                                    hoverBackgroundColor: 'rgba(230, 230, 230, 0)',
                                  }}
                                  formatResult={(item) => {
                                    if(that.state.activeSearchTransferBool){
                                      return (
                                        <div
                                          style={{  
                                            borderColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0)' : 'rgba(255, 255, 255, 0)',
                                            marginTop: '0vh',
                                            paddingTop: '3vh',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            paddingRight: '12px',
                                            backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(255, 255, 255, 0)' : 'rgba(255, 255, 255, 0)',
                                          }}
                                        >
                                          <span 
                                            style={{ 
                                              marginTop: '1vh',
                                              // paddingLeft: 10,
                                              textAlign: 'center',
                                              display: 'block', 
                                              textAlign: 'center',
                                              fontSize: 15,
                                              color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.3)',
                                            }}
                                          >
                                            {String(item.name).toUpperCase()} 
                                          </span>
                                        </div>
                                      )
                                    }
                                  }}
                                />
                              </div>
                              
                              <div
                                style={{
                                  width: '25vw',
                                  height: '6vh',
                                  // paddingLeft: '2vw',
                                  // flexDirection: 'row',
                                  // display: 'flex',
                                  position: 'absolute',
                                  padding: 0,
                                  // marginTop: '2vh',
                                  // backgroundColor: 'blue', 
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(230, 230, 230, 1)' : 'rgba(40, 44, 52, 1)', 
                                  top: '25vh',
                                  left: 0,
                                  right: 0,
                                  zIndex: 99999,
                                }}
                              >
                                <input 
                                  autocomplete="off" 
                                  type="text" 
                                  id="text" 
                                  boxShadow="none"
                                  outline="none"
                                  borderWidth={0}
                                  border="none"
                                  onBlur={() => {
                                    that.setState({
                                      destinationUsername: that.state.destinationUsername ? String(that.state.destinationUsername).toUpperCase() : that.state.destinationUsername
                                    })
                                  }}
                                  onChange={(event) => {
                                    if(String(event.target.value).length >= 2){
                                      that.setState({
                                        showSearchDropDownMenuBool: true,
                                        activeSearchTransferBool: true,
                                      })
                                    } else {
                                      that.setState({
                                        showSearchDropDownMenuBool: false
                                      })
                                    }
                                    that.setState({
                                      destinationUsername: event.target.value
                                    })
                                  }} 
                                  value={that.state.destinationUsername ? that.state.destinationUsername.toUpperCase() : ''}
                                  name="text"
                                  placeholderTextColor={'rgba(255, 255, 255, 1)'}
                                  placeholder={
                                    that.state.selectedLanguage == 'spanish' ? 
                                      "Usuario de Recipiente"
                                        :
                                      "Recipient Username"
                                  }                           
                                  style={{
                                      // opacity: 1,
                                      margin: 0,
                                      fontWeight: '600',
                                      fontFamily: 'Lato',
                                      color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)', 
                                      // paddingLeft: '11px',
                                      textAlign: 'center',
                                      textAlignVertical: 'center',
                                      fontSize: 18,
                                      height: '6vh',
                                      width: '25vw',
                                      borderLeftStyle: 'none',  
                                      borderTopStyle: 'none',  
                                      borderRadius: 0,
                                      borderBottomWidth: 0.1,
                                      borderBottomColor: that.state.mode_light_dark == 'light' ? 'rgba(177, 177, 177, 0.4)' : 'rgba(12, 12, 12, 0.4)',
                                      borderBottomStyle: 'none',
                                      backgroundColor: 'rgba(255, 255, 255, 0)',
                                      borderTopColor: 'rgba(41, 41, 41, 0.1)',
                                      borderTopStyle: 'solid', 
                                      zIndex: 99999,
                                    
                                  }}
                                />
                              </div> 
                            </div>
                          </div>
                          : 
                          null
                        }
                        {
                          that.state.moneyTransactionPreset == 'withdraw'
                          ?
                          null
                          : 
                          null
                        }

                        <div
                          style={{
                            marginBottom: 25,
                            height: '28vh',
                            marginTop: 0,
                            width: '25vw',
                            // backgroundColor: that.state.searchedUser_foundUsername ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, 0.1)',
                            borderRadius: 0,
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontSize: 14, 
                            fontWeight: '600',
                          }}
                          // disabled={true}
                        >
                          
                        </div>
                      </>}
</div>

                  </div> 

                </div>

              </div>

          </div>
        )
    );
  }
}

export default MemberTransactionsDesktopRender;
